import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import { ASSETS } from '../data/villaData';

export default function About() {
  const { t } = useLanguage();

  return (
    <section id="about" className="py-24 md:py-32 bg-[#faf6ef]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <p className="text-sm tracking-[0.3em] uppercase text-[#b8945e] font-medium mb-4">{t.about.eyebrow}</p>
            <h2 className="font-serif text-4xl md:text-6xl text-stone-900 mb-3 leading-tight">{t.about.title}</h2>
            <p className="text-xl text-stone-600 italic mb-8 font-light">{t.about.subtitle}</p>
            <div className="space-y-5 text-stone-700 leading-relaxed">
              <p>{t.about.p1}</p>
              <p>{t.about.p2}</p>
              <p>{t.about.p3}</p>
            </div>
            <div className="mt-10 inline-flex items-center gap-3 px-5 py-2.5 bg-[#b8945e]/10 rounded-full">
              <div className="w-2 h-2 bg-[#b8945e] rounded-full animate-pulse" />
              <span className="text-sm font-semibold text-[#b8945e] tracking-wide">{t.about.season}</span>
            </div>
          </div>

          <div className="relative">
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-4">
                <div className="aspect-[3/4] overflow-hidden rounded-2xl shadow-xl">
                  <img src={ASSETS.living} alt="Living" className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" />
                </div>
                <div className="aspect-square overflow-hidden rounded-2xl shadow-xl">
                  <img src={ASSETS.poolside} alt="Poolside" className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" />
                </div>
              </div>
              <div className="space-y-4 pt-12">
                <div className="aspect-square overflow-hidden rounded-2xl shadow-xl">
                  <img src={ASSETS.bedroom} alt="Bedroom" className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" />
                </div>
                <div className="aspect-[3/4] overflow-hidden rounded-2xl shadow-xl">
                  <img src={ASSETS.heroPool} alt="Pool" className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" />
                </div>
              </div>
            </div>
            <div className="absolute -bottom-6 -left-6 w-32 h-32 border-2 border-[#b8945e] rounded-2xl -z-10" />
            <div className="absolute -top-6 -right-6 w-24 h-24 bg-[#b8945e]/20 rounded-2xl -z-10" />
          </div>
        </div>
      </div>
    </section>
  );
}
